/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     .modal{padding:0!important;border-radius:0!important}[_nghost-%COMP%]     .modal-dialog{height:100%;width:100%}[_nghost-%COMP%]     .modal-content, [_nghost-%COMP%]     .modal-content-wrapper{height:100%}[_nghost-%COMP%]     .modal-body{display:flex;align-items:center;justify-content:center;height:100%;max-height:100%!important;width:100%}"];
export { styles as styles };
